import { PaymentTablesColumns } from './components/tables/types';

export const NEW_CREDIT_CARD_VALUE = 'newCreditCard';

export const MAX_PREAUTHORIZATION_EXPIRATION_DAYS = 28;

export const PAYMENTS_LIMIT = 5000;

export const PAYMENTS_TABLE_COLUMNS = Object.values(PaymentTablesColumns);
